import cn from 'classnames'
import Avatar from 'ext-ui/components/Avatar/Avatar'
import React, { ComponentProps, ReactElement } from 'react'
import { getMccIcon } from 'src/feature/MerchantIcon/mccIconMapping'
import style from 'src/feature/MerchantIcon/MerchantIcon.style'
import { MccGroupKey } from 'src/models/transaction.models'

type MerchantIconProps = {
  className?: string
  merchantImgSrc?: string
  mccGroupKey: MccGroupKey
  size?: number
} & Omit<ComponentProps<'div'>, 'children'>

function MerchantIcon(props: MerchantIconProps): ReactElement {
  const { className = '', merchantImgSrc, mccGroupKey, size, ...rest } = props

  const getMccFallback = () => {
    if (!mccGroupKey) return null

    const IconComponent = getMccIcon(mccGroupKey)
    return <IconComponent className="w-full h-full" />
  }

  return (
    <div className={cn('MerchantIcon', className)} css={style} {...rest}>
      <Avatar
        imageSrc={merchantImgSrc}
        fallback={getMccFallback()}
        variant="outlined"
        size={size}
      />
    </div>
  )
}

export default MerchantIcon
